import { render, staticRenderFns } from "./financeiro-relatorio-configuracao.vue?vue&type=template&id=f1482246&scoped=true"
import script from "./financeiro-relatorio-configuracao.vue?vue&type=script&lang=ts"
export * from "./financeiro-relatorio-configuracao.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-relatorio-configuracao.vue?vue&type=style&index=0&id=f1482246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1482246",
  null
  
)

export default component.exports